import "@tento-ui/component-builtin";
import "@tento-ui/components/list/list-cell-layout";

import { Column } from "@tento-ui/component-builtin";
import { ListCellLayout } from "@tento-ui/components/list/list-cell-layout";
import { Typography } from "@tento-ui/ui/typography";

export function $makeNuxTextListCell(
  props: NuxTextListCell.Props,
): ListCellLayout<HTMLElement> {
  const $title = Typography.p(props.title);
  $title.assignStyles({
    "--margin-top": "0px",
    "--margin-bottom": "0px",
    color: "var(--text-pri)",
    fontWeight: "500",
  });

  const $caption = Typography.caption(props.caption);
  $caption.assignStyles({
    "--margin-top": "6px",
    "--font-size": "var(--text-8px)",
    color: "var(--text-ter)",
  });

  const $content = Column.make();
  $content.assignStyles({ alignItems: "start" });
  $content.appendChild($title);
  $content.appendChild($caption);

  const $cell = props.$icon
    ? ListCellLayout.makeWith({ $icon: props.$icon, $content })
    : ListCellLayout.makeWith({ $content });
  $cell.assignStyles({
    "--cell-align": "flex-start",
    "--list-cell-background-color": "var(--bg-surface-light)",
    "--list-cell-padding": "10px 12px",
  });

  return $cell;
}

export namespace NuxTextListCell {
  export type Props = {
    title: string;
    caption: string;
    $icon: Option<HTMLElement | SVGElement>;
  };
}
